const devConfig = {
    isBuild: false,
    loginRedirect: false,
    language: "zh",
    workerURL: "./js/BaseCore/worker.js",
    userWorkerURL: "./js/BaseCore/userDBWorker.js",
    libraryWorkerURL: "./js/BaseCore/libraryWorker.js",
    sourcePath: "/",
};

const prodConfig = {
    isBuild: true,
    loginRedirect: false,
    language: window.GLOBAL.DEPLOY_TYPE === "cn" ? "zh" : "en",
    workerURL: `./js/BaseCore/worker.js?${Math.round(Math.random() * 1000000)}`,
    userWorkerURL: `./js/BaseCore/userDBWorker.js?${Math.round(Math.random() * 1000000)}`,
    libraryWorkerURL: `./js/BaseCore/libraryWorker.js?${Math.round(Math.random() * 1000000)}`,
    sourcePath: "/$HTTP_BASE_PATH/",
};

let finalConfig = process.env.NODE_ENV !== "production" ? devConfig : prodConfig;

export default finalConfig;
